import { useMemo } from 'react';
import { gid } from '../utils';

const PE_CRATING_FEE_VARIANTS = { 100: '40645041750113', 250: '40645041782881' };
const MS_CRATING_FEE_VARIANTS = { '12 Feet': '41048476188769', '15 Feet': '41048476221537', '17 Feet': '41048494473313' };

const QUICK_RELEASE_VARIANT = '32790441590881';
const CANTI_QUICK_RELEASE_VARIANT = '41939353829473';

const SHADE_STRUCTURES_DRAWINGS = {
  unsealed: '32790391423073',
  sealed: '32790391390305',
  sealedPhysical: '41075275399265',
};

const MS_DRAWINGS = {
  unsealed: '40777863102561',
  sealed: '40777863069793',
};

const SURFACE_MOUNT_VARIANTS_MS = {
  'Center Post Square Umbrella Shade': '42441776726113',
  'Cantilever Square Umbrella Shade': '42441776693345',
  'Pyramid Roof Shade Structure with 4 Posts': '42441776758881',
  'Hip Roof Shade Structure with 4 Posts': '42441776660577',
};

const SURFACE_MOUNT_LOOKUPS = [
  [t => t === 'Single Post Pyramid Cantilever Shade Structure', '32796101214305'],
  [t => t.includes('Hip Roof Shade Structure with 4 Posts'), '32795900706913'],
  [t => t === 'Hip Roof Shade Structure with 2 Posts', '39478314172513'],
  [t => t === 'Single Post Pyramid Roof Shade Structure', '32795900739681'],
  [t => t === 'Mariner Pyramid Shade Structure', '32796048326753'],
  [t => t === 'Mariner Hexagon Shade Structure with 6 Posts', '32796071002209'],
  [t => t === 'Hexagon Shade Structure with 6 Posts', '32796064022625'],
  [t => t === 'Superspan Hip Roof Shade Structure', '32796053831777'],
  [t => t === 'Extended Superspan Hip Roof Shade Structure with 6 Posts', '32796055273569'],
  [t => t === '3 Point Sail Shade Structure', '32796073623649'],
  [t => t === '4 Point Hypar Sail Shade Structure', '32796086108257'],
  [t => t.includes('Coolbrella'), '32796056911969'],
  [t => t.includes('Solana'), '32796112420961'],
  [t => t.includes('Aurora'), '32796113109089'],
  [t => t.includes('Sahara'), '32796113961057'],
  [t => t.includes('Pegasus'), '32796202664033'],
  [t => t.includes('Lifeguard Shade'), '32796105605217'],
  [t => t.includes('Flower Shade') || t.includes('Butterfly Wings'), '32796110815329'],
  [t => t === 'Hexagon Single Post Umbrella Roof Shade Structure', '32796243951713'],
  [t => t === 'Octagon Shade Structure with 8 Posts', '32796068184161'],
  [t => t === 'Triangle Shade Structure with 3 Posts', '32796069757025'],
  [t => t === 'Full Cantilever Hip Roof Shade Structure', '32796104523873'],
  [t => t === 'Wave Shade Structure with 4 Posts', '32796057796705'],
];

const MS_SHADE_PADS_4 = {
  'Center Post Square Umbrella Shade': '42441873031265',
  'Cantilever Square Umbrella Shade': '42441873064033',
  'Pyramid Roof Shade Structure with 4 Posts': '42441872998497',
  'Hip Roof Shade Structure with 4 Posts': '42441872965729',
};

const MS_SHADE_PADS_6 = {
  'Center Post Square Umbrella Shade': '42441899671649',
  'Cantilever Square Umbrella Shade': '42441899704417',
  'Pyramid Roof Shade Structure with 4 Posts': '42441899638881',
  'Hip Roof Shade Structure with 4 Posts': '42441878995041',
};

const TRIKE_STRIPE_VARIANTS = {
  Talladega: '32590873296993',
  Bristol: '32590873329761',
  'Formula One': '32590873362529',
  Daytona: '32590873231457',
  Atlanta: '32590873264225',
};

const PARK_SIGN_VARIANTS = {
  fenceAttachment: '39806724800609',
  postAttachment: '39806725226593',
  customHeaderSign: '39806726930529',
  slidingDoorLock: '39806726504545',
};

const UPLAY_KITS = [
  ["Maddie's Chase Play System", 'In-Ground Kit (*Required)', '32799017533537'],
  ["Clingman's Dome Play System", 'Anchor Bolt', '39261259464801'],
  ["Clingman's Dome Play System", 'In-Ground Kit', '32799017828449'],
  ['Discovery Mountain Playground', 'In-Ground Kit Loose Fill Surfacing', '32831861686369'],
  ['Discovery Mountain Playground', 'In-Ground Kit Unitary Surfacing', '32831862014049'],
  ['Discovery Hilltop Playground', 'In-Ground Kit Loose Fill Surfacing', '32829608362081'],
  ['Discovery Hilltop Playground', 'In-Ground Kit Unitary Surfacing', '32829614293089'],
  ['Discovery Center Spring', 'In-Ground Kit', '40254656708705'],
  ['Discovery Center Super Sprout', 'In-Ground Kit', '40254648942689'],
  ['Discovery Center Sapling', 'In-Ground Kit', '40254664507489'],
  ['Discovery Center Seedling', 'In-Ground Kit', '40254655594593'],
  ['Big Sky Playground', 'Anchor Bolt', '39261259497569'],
  ['Big Sky Playground', 'In-Ground Kit', '32799017893985'],
  ['Rainbow Lake Play System', 'Anchor Bolt', '39261259432033'],
  ['Rainbow Lake Play System', 'In-Ground Kit', '32799017730145'],
  ['Bighorn Play System Playground', 'Anchor Bolt', '39261259366497'],
  ['Bighorn Play System Playground', 'In-Ground Kit', '32799017599073'],
  ["Keegan's Kastle Play System", 'Anchor Bolt', '39261259268193'],
  ["Keegan's Kastle Play System", 'In-Ground Kit', '32799017369697'],
  ["Falcon's Roost", 'Anchor Bolt', '39261259235425'],
  ["Falcon's Roost", 'In-Ground Kit', '32799017304161'],
  ["Hawk's Nest Play System", 'Anchor Bolt', '39261259202657'],
  ["Hawk's Nest Play System", 'In-Ground Kit', '32799017238625'],
  ['Deer Creek Playground', 'Anchor Bolt', '39261259169889'],
  ['Deer Creek Playground', 'In-Ground Kit', '32799017173089'],
  ['South Fork Play System', 'Anchor Bolt', '39261259137121'],
  ['South Fork Play System', 'In-Ground Kit', '32799017107553'],
  ['Cumberland Gap Play System', 'Anchor Bolt', '39261259104353'],
  ['Cumberland Gap Play System', 'In-Ground Kit', '32799017042017'],
  ['Signal Springs Play System', 'Anchor Bolt', '39261259071585'],
  ['Signal Springs Play System', 'In-Ground Kit', '32799016976481'],
  ['Carsons Canyon Play System', 'Anchor Bolt', '39261259038817'],
  ['Carsons Canyon Play System', 'In-Ground Kit', '32799016910945'],
  ["Pike's Peak Playground Play System", 'Anchor Bolt', '39261259006049'],
  ["Pike's Peak Playground Play System", 'In-Ground Kit', '32799016845409'],
  ['Treasure Hollow Play System', 'In-Ground Kit (*Required)', '32799017926753'],
  ['Slide Mountain Play System', 'In-Ground Kit (*Required)', '32799017762913'],
  ['Boulder Point Play System Playground', 'Anchor Bolt', '39261259333729'],
  ['Boulder Point Play System Playground', 'In-Ground Kit', '32799017500769'],
  
];

const METAL_TRASH_LOOKUPS = [
  ['In Ground Kit', '39621291933793'],
  ['Surface Mount Kit', '39621291933793'],
  ['Flat 32 Gal / 8" Opening', '39621166792801'],
  ['Flat 32 Gal / 14" Opening', '39621166825569'],
  ['Flat 55 Gal / 8" Opening', '39621166858337'],
  ['Flat 55 Gal / 14" Opening', '39621166891105'],
  ['Rain Bonnet 32 Gal / 8" Opening', '39621103681633'],
  ['Rain Bonnet 32 Gal / 14" Opening', '39621103714401'],
  ['Rain Bonnet 55 Gal / 8" Opening', '39621103747169'],
  ['Rain Bonnet 55 Gal / 14" Opening', '39621103779937'],
  ['Ash Lid 32 Gal / 8" Opening', '39621055905889'],
  ['Ash Lid 32 Gal / 14" Opening', '39621095358561'],
  ['Ash Lid 55 Gal / 8" Opening', '39621055971425'],
  ['Ash Lid 55 Gal / 14" Opening', '39621095391329'],
  ['32 Gal Liner', '39621045518433'],
  ['55 Gal Liner', '39621045551201'],
];



const QUOTE_ONLY_PRODUCT_TYPES = new Set(['Shades', 'Water Slides', 'Bleachers & Sports Benches']);

const normalizeMatch = (s) =>
  String(s ?? '')
    .toLowerCase()
    // normalize common dash variants
    .replace(/[\u2010-\u2015]/g, '-')
    // collapse whitespace
    .replace(/\s+/g, ' ')
    .trim();

export const constructLineItems = (items, customerState) => {
  let lineItems = [];
  let maxPECratingFee = 0;
  const msCratingFeeCounts = {};

  for (const item of items) {
    const brand = item.brand ?? item.vendor;
    const customAttributes = [];

    if (item.manual) {
      customAttributes.push({ key: 'Installation Manual', value: item.manual });
    }

    if (item.packingList) {
      customAttributes.push({ key: 'Packing List', value: item.packingList });
    }

    if ((item.tags?.includes('Hide Price') || item.quoteOnly) && QUOTE_ONLY_PRODUCT_TYPES.has(item.productType)) {
      customAttributes.push({ key: 'CUSTOM PRODUCT', value: 'CUSTOM QUOTE' });
    }

    let hasQuickRelease = false;
    let hasCantileverQuickRelease = false;
    let hasUnsealedDrawingsUSA = false;
    let hasSealedDrawingsUSA = false;
    let hasSealedPhysicalDrawingsUSA = false;
    let hasUnsealedDrawingsMS = false;
    let hasSealedDrawingsMS = false;
    let isSurfaceMountShade = false;
    let hasMSShadePads4 = false;
    let hasMSShadePads6 = false;
    let hasFenceAttachmentKit = false;
    let hasPostAttachmentKit = false;
    let hasSlidingDoorLock = false;
    let hasCustomHeaderSign = false;
    let hasTrikeStripeKit = false;
    const triggeredUplayVariants = new Set();
    const triggeredTrashVariants = new Set();

    for (const option of (item.options ?? [])) {
      const logicKey = option.key ?? option.label ?? option.name;
      const displayKey = option.label ?? option.name ?? option.key;
      const { value } = option;
      if (!logicKey || !value) continue;

      if (displayKey?.startsWith('_')) {
        customAttributes.push({ key: displayKey.replace(/^_/, ''), value });
      } else {
        customAttributes.push({ key: displayKey, value });
      }

      if (value === 'Quick Release') {
        if (item.title?.includes('Single Post Pyramid Cantilever Shade Structure')) {
          hasCantileverQuickRelease = true;
        } else {
          hasQuickRelease = true;
        }
      }

      if (brand === 'Shade Structures') {
        if (value === 'Unsealed Engineered Drawings') {
          hasUnsealedDrawingsUSA = true;
        } else if (value === 'Sealed Engineered Drawings' || value === 'Sealed Digital Engineered Drawings') {
          hasSealedDrawingsUSA = true;
        } else if (value === 'Sealed Physical Engineered Drawings') {
          hasSealedPhysicalDrawingsUSA = true;
        } else if (value === 'Unsealed Engineered Drawings,Sealed Digital Engineered Drawings') {
          hasUnsealedDrawingsUSA = true;
          hasSealedDrawingsUSA = true;
        } else if (customerState === 'California' && value !== 'Unsealed Engineered Drawings') {
          hasUnsealedDrawingsUSA = true;
        }
      }

      if (brand === 'Modern Shade') {
        if (value === 'Unsealed Engineered Drawings') {
          hasUnsealedDrawingsMS = true;
        } else if (value === 'Sealed Engineered Drawings') {
          hasSealedDrawingsMS = true;
        } else if (value === 'Unsealed Engineered Drawings,Sealed Engineered Drawings') {
          hasUnsealedDrawingsMS = true;
          hasSealedDrawingsMS = true;
        } else if (customerState === 'California' && value !== 'Unsealed Engineered Drawings') {
          hasUnsealedDrawingsMS = true;
        }
      }

      if (value === 'Surface Mount Anchor Bolts & Plates' || value === 'Recessed Mount Anchor Bolts & Plates') {
        isSurfaceMountShade = true;
      }

      if (value.includes("4' Post Pads")) hasMSShadePads4 = true;
      if (value.includes("6' Post Pads")) hasMSShadePads6 = true;

      if (value.includes('Fence Attachment Kit')) hasFenceAttachmentKit = true;
      if (value.includes('Post Attachment Kit')) hasPostAttachmentKit = true;
      if (value.includes('Sliding Door Lock')) hasSlidingDoorLock = true;
      if (value.includes('Custom Header Sign')) hasCustomHeaderSign = true;

      if (logicKey === 'trike_path_stripe_kit') hasTrikeStripeKit = true;

      if (item.title) {
        const normTitle = normalizeMatch(item.title);
        const normValue = normalizeMatch(value);
        for (const [titleContains, valueContains, variantId] of UPLAY_KITS) {
          if (normTitle.includes(normalizeMatch(titleContains)) && normValue.includes(normalizeMatch(valueContains))) {
            triggeredUplayVariants.add(variantId);
          }
        }
      }

      if (item.title?.includes('Metal Trash Receptacle')) {
        for (const [valueContains, variantId] of METAL_TRASH_LOOKUPS) {
          if (value.includes(valueContains)) {
            triggeredTrashVariants.add(variantId);
          }
        }
      }
    }

    lineItems.push({
      variantId: gid(item.variantId),
      // variantId: item.variantId,
      quantity: item.quantity,
      customAttributes,
    });

    if (hasQuickRelease) {
      lineItems.push({ variantId: gid(QUICK_RELEASE_VARIANT), quantity: item.quantity });
    }
    if (hasCantileverQuickRelease) {
      lineItems.push({ variantId: gid(CANTI_QUICK_RELEASE_VARIANT), quantity: item.quantity });
    }

    if (hasUnsealedDrawingsUSA) {
      lineItems.push({ variantId: gid(SHADE_STRUCTURES_DRAWINGS.unsealed), quantity: item.quantity });
    }
    if (hasSealedDrawingsUSA) {
      lineItems.push({ variantId: gid(SHADE_STRUCTURES_DRAWINGS.sealed), quantity: item.quantity });
    }
    if (hasSealedPhysicalDrawingsUSA) {
      lineItems.push({ variantId: gid(SHADE_STRUCTURES_DRAWINGS.sealedPhysical), quantity: item.quantity });
    }

    if (hasUnsealedDrawingsMS) {
      lineItems.push({ variantId: gid(MS_DRAWINGS.unsealed), quantity: item.quantity });
    }
    if (hasSealedDrawingsMS) {
      lineItems.push({ variantId: gid(MS_DRAWINGS.sealed), quantity: item.quantity });
    }

    if (isSurfaceMountShade && item.title) {
      let mountVariantId;
      if (brand === 'Modern Shade') {
        mountVariantId = SURFACE_MOUNT_VARIANTS_MS[item.title];
      } else {
        const match = SURFACE_MOUNT_LOOKUPS.find(([fn]) => fn(item.title));
        if (match) mountVariantId = match[1];
      }
      if (mountVariantId) {
        lineItems.push({ variantId: gid(mountVariantId), quantity: item.quantity });
      }
    }

    if (brand === 'Modern Shade') {
      if (item.title && (hasMSShadePads4 || hasMSShadePads6)) {
        const padsVariantId = hasMSShadePads6
          ? MS_SHADE_PADS_6[item.title]
          : MS_SHADE_PADS_4[item.title];
        if (padsVariantId) {
          lineItems.push({ variantId: gid(padsVariantId), quantity: item.quantity });
        }
      }

      const msCratingVariantId = MS_CRATING_FEE_VARIANTS[item.cratingFee];
      if (msCratingVariantId) {
        msCratingFeeCounts[msCratingVariantId] = (msCratingFeeCounts[msCratingVariantId] ?? 0) + (item.quantity ?? 1);
      }
      
      if (customerState === 'California' && item.frFabricFee) {
        lineItems.push({ variantId: gid(item.frFabricFee), quantity: item.quantity });
      }
    }

    if (hasTrikeStripeKit && item.title) {
      const trikeKey = Object.keys(TRIKE_STRIPE_VARIANTS).find(k => item.title.includes(k));
      if (trikeKey) {
        lineItems.push({ variantId: gid(TRIKE_STRIPE_VARIANTS[trikeKey]), quantity: item.quantity });
      }
    }

    if (hasFenceAttachmentKit) {
      lineItems.push({ variantId: gid(PARK_SIGN_VARIANTS.fenceAttachment), quantity: item.quantity });
    }
    if (hasPostAttachmentKit) {
      lineItems.push({ variantId: gid(PARK_SIGN_VARIANTS.postAttachment), quantity: item.quantity });
    }
    if (hasSlidingDoorLock) {
      lineItems.push({ variantId: gid(PARK_SIGN_VARIANTS.slidingDoorLock), quantity: item.quantity });
    }
    if (hasCustomHeaderSign) {
      lineItems.push({ variantId: gid(PARK_SIGN_VARIANTS.customHeaderSign), quantity: item.quantity });
    }

    for (const variantId of triggeredUplayVariants) {
      lineItems.push({ variantId: gid(variantId), quantity: item.quantity });
    }

    for (const variantId of triggeredTrashVariants) {
      lineItems.push({ variantId: gid(variantId), quantity: item.quantity });
    }

    

    if (brand === 'Playground Equipment' && item.cratingFee) {
      if (PE_CRATING_FEE_VARIANTS[item.cratingFee] && item.cratingFee > maxPECratingFee) {
        maxPECratingFee = item.cratingFee;
      }
    }
 
  }

  if (PE_CRATING_FEE_VARIANTS[maxPECratingFee]) {
    lineItems.push({ variantId: gid(PE_CRATING_FEE_VARIANTS[maxPECratingFee]), quantity: 1 });
  }

  for (const [variantId, quantity] of Object.entries(msCratingFeeCounts)) {
    lineItems.push({ variantId: gid(variantId), quantity });
  }

  return lineItems;
};

export const useConstructLineItems = (items, customerState) => {
  return useMemo(() => constructLineItems(items, customerState), [items, customerState]);
};

// export default useConstructLineItems;
